import { render } from "./QuotesSection.vue?vue&type=template&id=c4170e9c&scoped=true"
import script from "./QuotesSection.vue?vue&type=script&lang=js"
export * from "./QuotesSection.vue?vue&type=script&lang=js"

import "./QuotesSection.vue?vue&type=style&index=0&id=c4170e9c&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4170e9c"]])

export default __exports__